// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel {
    static getAttributeTypeMap() {
        return ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel.attributeTypeMap;
    }
}
ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel.discriminator = undefined;
ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel.additionalProperties = false;
ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel.attributeTypeMap = [
    {
        "name": "fileUrl",
        "baseName": "fileUrl",
        "type": "string"
    },
];
//# sourceMappingURL=scriptsDocumentsV2FillablePdfGenerateFieldsRequestModel.js.map